export type GroupedRow = {
  values: Record<string, number>
  group: string
  total: number
}

export type Groups = {
  max: number
  rows: GroupedRow[]
  keys: string[]
}

export function makeGroups<T extends Record<string, any>>(
  data: T[],
  getGroup: (x: T) => string,
  getKey: (x: T) => string,
  getValue: (x: T) => number,
): Groups {
  let max: number = 0
  const rowsMap = new Map<string, GroupedRow>()
  const keysSet = new Set<string>()

  data.forEach((x) => {
    const group = getGroup(x)
    const key = getKey(x)
    const value = getValue(x)
    max = Math.max(max, value)
    keysSet.add(key)
    if (!rowsMap.has(group)) {
      const row: GroupedRow = { group: group, total: 0, values: {} }
      rowsMap.set(group, row)
    }

    const row = rowsMap.get(group)!
    row.total += value
    row.values[key] = value
    rowsMap.set(group, row)
  })

  return {
    rows: Object.values(Object.fromEntries(rowsMap.entries())),
    keys: Array.from(keysSet),
    max,
  }
}

export const emptyGroups: Groups = {
  rows: [],
  keys: [],
  max: 0,
}
